import { render, staticRenderFns } from "./galleriaImmagini.vue?vue&type=template&id=ec8fd6e4&scoped=true&"
import script from "./galleriaImmagini.vue?vue&type=script&lang=ts&"
export * from "./galleriaImmagini.vue?vue&type=script&lang=ts&"
import style0 from "./galleriaImmagini.vue?vue&type=style&index=0&id=ec8fd6e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec8fd6e4",
  null
  
)

export default component.exports